import { ApproveWithdraw } from "./approveWithdraw";
import { createWithdraw } from "./createWithdraw";
import { getAmount } from "./getAmount";
import { getAvailableAmount } from "./getAvailableAmount";
import { getWithdrawById } from "./getWithdrawById";
import { getWithdrawProof } from "./getWithdrawProof";
import { ManuallyWithdraw } from "./manuallyWithdraw";
import { RefuseWithdraw } from "./refuseWithdraw";
import { withdraw } from "./withdraw";

export const WithdrawService = {
  withdraw,
  getAvailableAmount,
  getAmount,
  getWithdrawById,
  getWithdrawProof,
  createWithdraw,
  ApproveWithdraw,
  RefuseWithdraw,
  ManuallyWithdraw,
};
